import axios from 'axios';
import { ISubscription } from '../contracts/psc-subscription.contract';
import ConfigService from './config.service';

const subscribe = async (): Promise<ISubscription> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/Subscription/Subscribe`);
    return res.data;
};

const unsubscribe = async (): Promise<ISubscription> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/Subscription/Unsubscribe`);
    return res.data;
};

const getStatus = async (): Promise<ISubscription> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/Subscription/Status`);
    return res.data;
};

const SubscriptionService = {
    subscribe,
    unsubscribe,
    getStatus
};

export default SubscriptionService;
